export default [
  {
    path: '/car-attendances',
    name: 'car-attendance',
    meta: { requiresAuth: true },
    component: () => import('@/pages/car-attendance/index.vue')
  }
]
